import './common/rem'
import Vue from 'vue'
import App from './App.vue'
import store from './store/index'
import {
  router
} from './router'
// import { WZUtils } from './common/globals';
// import { now } from './common/utils';

// function stopTimer(vm) {
//   if(vm.timer) {
//     clearInterval(vm.timer)
//   }
//   vm.timer = null
// }
import {
  mapState,
  mapActions,
  mapGetters
} from 'vuex';

import components from './components/index.js';
// import WzNavbar from './components/wz-navbar.vue';
// import TimerNum from './components/timer-num.vue';
// import ButtonBuy from './components/goods-button-buy.vue';
// import PreGoodsList from './components/pre-goods-list.vue';

Vue.use(components)
// Vue.component('wz-navbar', WzNavbar)
// Vue.component('timer-num', TimerNum)
// Vue.component('goods-button-buy', ButtonBuy)
// Vue.component('pre-goods-list', PreGoodsList)
// alert(process.env.VUE_APP_CDN_HOST)

new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App),
  methods: {
    ...mapActions(['timerStart',
      'timerStop',
      'getUserInfo',
      'getOrderInfo'
    ])
  },
  computed: {
    ...mapState(['userInfo', 'preMap']),
    ...mapGetters(['canPayLast', 'myGidPre', 'myGidLast', 'needAddress'])
  },
  created() {
    // if (!this.preMap) {
    this.getOrderInfo({}).then(() => {
      const $route = this.$route
      if (!$route || $route.name !== 'index') {// 仅首页提示
        return
      }
      
      if (this.canPayLast) {// 尾款支付提示
        this.$dialog.confirm({
          title: '尾款支付提醒',
          message: '<div style="text-align:left;">双11当天24点前未如期支付尾款的，逾期将不再享受双11特惠价，而且定金不退还。<br>为避免损害您的利益，请记得一定要及时支付尾款！</div>',
          confirmButtonText: '去支付'
        }).then(() => {
          this.$router.push(`/goods/${this.myGidPre}`)
          // on confirm
        })
      } else if(this.needAddress) {
        this.$dialog.confirm({
          title: '填写收货人信息',
        message: '<div style="text-align:left;">您购买的商品中存在部分实体物品，需要邮寄给您，请您务必仔细填写相关收货信息！</div>',
        confirmButtonText: '去补充'
        }).then(() => {
          this.$router.push(`/buy/${this.myGidLast}`)
        })
      }
    })
    // }

    // if (!this.userInfo) {
      this.getUserInfo()
    // }
    this.timerStart()
  },
  beforeDestroy() {
    this.timerStop()
  }
})
